import { createFileRoute } from '@tanstack/react-router';
import { PurchasePage } from '@/components/purchases/purchase-page';

export const Route = createFileRoute('/expenses/bills/$documentId')({ component: View });

function View() {
  const { documentId } = Route.useParams();
  return <PurchasePage kind="bill" id={documentId} />;
}
